const settingsModalComponentModule = {
  namespaced: true,
  modules: {},
  state: () => ({
    storedContexts: []
  }),
  getters: {},
  mutations: {
    addToStoredContexts(state, { contextId }) {
      if (!state.storedContexts.includes(contextId)) {
        state.storedContexts.push(contextId);
      }
    },
    emptyStoredContexts(state) {
      state.storedContexts = [];
    }
  },
  actions: {
    updateStoredContext({ rootState, commit }, { contextId }) {
      console.log('rootState', rootState);
      commit('addToStoredContexts', { contextId });
      sessionStorage.setItem(`${contextId}.views.context`, JSON.stringify(rootState.views.context));
    },
    updateNewContextState({ state, rootState }, { contextId }) {
      if (state.storedContexts.includes(contextId)) {
        rootState.views.context = JSON.parse(sessionStorage.getItem(`${contextId}.views.context`));
      }
    }
  }
};

export default settingsModalComponentModule;
